exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/react-input-calendar/~/core-js/library/modules/_wks-ext.js
// module id = 339
// module chunks = 3